export default [{
  name: 'pirate',
  path: '/pirate',
  component: require('@/views/pirate/Pirate.vue').default
}]
